var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabCard"},[_c('el-tabs',[_c('el-tab-pane',{attrs:{"label":"订单字段"}},[_c('FieldSet',{attrs:{"type":1}})],1),_c('el-tab-pane',{attrs:{"label":"报价单字段"}},[_c('FieldSet',{attrs:{"type":3}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }